import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'eui-toolbar-environment',
    templateUrl: './toolbar-environment.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiToolbarEnvironmentComponent {

    @HostBinding() class = 'eui-toolbar-environment';

    constructor(
    ) {}

}
